import { WrappedFieldProps } from 'redux-form';
import styled from 'styled-components';

import CheckboxBase from 'inquiry/components/CheckboxBase';
import FormError from 'inquiry/components/FormError';
import { containerStyles } from 'inquiry/mixins/form';
import { InputCheckboxComponent } from 'lib/interfaces/ui-components';

const Container = styled('div')`
  ${containerStyles}
`;

export interface ThemedFormCheckboxProps {
  id: string;
  autoFocus?: boolean;
  label?: string;
  descriptionText?: string;
  className?: string;
  styles?: InputCheckboxComponent['styles'];
  disabled?: boolean;
}

const ThemedFormCheckbox = (props: WrappedFieldProps & ThemedFormCheckboxProps) => {
  const {
    className,
    input,
    meta: { error, submitFailed },
    autoFocus,
    label,
    descriptionText,
    id,
    styles,
    disabled,
    ...passthroughProps
  } = props;

  const hasError = !!(error && submitFailed);

  return (
    <Container className={className}>
      <CheckboxBase
        {...input}
        {...passthroughProps}
        autoFocus={autoFocus}
        disabled={disabled}
        id={id}
        value={input.value}
        styles={styles}
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        labelText={label}
        descriptionText={descriptionText}
        hasError={hasError}
        aria-errormessage={`${id}--error`}
        aria-describedby={`${id}--error`}
      />
      <FormError id={`${id}--error`} hasError={hasError} errorMessage={error} styles={styles} />
    </Container>
  );
};

export default ThemedFormCheckbox;
